export const PLACE_ORDER = "PLACE_ORDER";
export const CHECKOUT_EMPTY = "CHECKOUT_EMPTY";
